import Siprec, { applyRelations } from './factory/Siprec'
import Locale from '@/locale'

import moment from 'moment'

let Record = Siprec({
  name: 'recordings',
  enums: {
    direction: {
      OUT: Locale.t('callDirection.out'),
      IN: Locale.t('callDirection.in')
    },
    state: {
      ANSWERED: Locale.t('callState.answered'),
      NOT_ANSWERED: Locale.t('callState.notAnswered'),
      BUSY: Locale.t('callState.busy')
    },
    reason: {
      UNKNOWN: 'recordings.reason.unknown',
      TIME_MISMATCH: 'recordings.reason.timeMismatch',
      RECORDING_DISABLED: 'recordings.reason.recordingDisabled',
      NUMBER_BLACKLIST: 'recordings.reason.numberBlacklist'
    }
  },
  methods: {
    isPlayable (item) {
      return !item.archived &&
        item.fileName
    },

    getBasename (item) {
      try {
        return item.fileName.split('/').pop().split('.').shift()
      } catch (e) {
        return 'recording_' + moment(item.callDate).format('YYYY-MM-DD_HH:mm')
      }
    },

    getFilename (item) {
      // @TODO: Wtf is this, why is it so complicated
      let ext
      try {
        ext = item.fileName.split('.').pop()
      } catch (e) {
        ext = 'wav'
      }
      return Record.getBasename(item) + '.' + ext
    },

    getMetadata (item) {
      return item
        .fetch('recordingMetadata')
        .then(result => {
          item.recordingMetadata = result.items
          return (
            [
              `<?xml version='1.0' encoding='UTF-8'?>`,
              `<cdr>`,
              `\t<callDate>${item.callDate}</callDate>`,
              `\t<source>${item.source}</source>`,
              `\t<destination>${item.destination}</destination>`,
              `\t<direction>${item.direction}</direction>`,
              `\t<state>${item.state}</state>`,
              `\t<duration>${item.duration}</duration>`,
              `</cdr>`
            ].join('\n') +
            '\n\n' +
            item.recordingMetadata.map(item => item.metadata).join('\n\n')
          ).replace(/\n/g, '\r\n')
        })
    }
  }
})

Record.saveTags = (item) => {
  let updated = {
    _links: item._links,
    _self: item._self,
    _sources: item._sources,
    tags: item.tags
  }
  return applyRelations(updated, {})
}

export default Record



// WEBPACK FOOTER //
// ./src/models/Record.js